import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DialogClose } from "@radix-ui/react-dialog";
import { CircleAlert } from "lucide-react";
import React from "react";
import { useCanvasId } from "@/utils/utils";

type CleanAndDiscardGitChangesModalProps = {
  uncommittedChangedFiles: string[];
  discardChanges: () => void;
  loadingDiscard: boolean;
};

function CleanAndDiscardGitChangesModal({
  discardChanges,
  loadingDiscard,
  uncommittedChangedFiles,
}: CleanAndDiscardGitChangesModalProps) {
  const canvasId = useCanvasId();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary" disabled={loadingDiscard} size="sm">
          Clean & Discard
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-4">
            <CircleAlert className="text-destructive p-1 bg-secondary rounded-sm" />{" "}
            Clean and Discard?
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to clean and discard the following changes?
            This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <ul className="max-h-[30vh] overflow-auto space-y-3 my-5">
          {uncommittedChangedFiles?.map((filename) => {
            const baseFilename = filename.substring(
              filename.indexOf(canvasId) + canvasId.length + 1
            );
            return (
              <li
                className="text-xs text-muted-foreground"
                key={`discard-row-${baseFilename}`}
              >
                {baseFilename}
              </li>
            );
          })}
        </ul>
        <DialogFooter>
          <DialogClose asChild>
            <Button className="w-full" variant="secondary">
              Cancel
            </Button>
          </DialogClose>
          <Button
            className="w-full"
            variant="destructive"
            onClick={() => discardChanges()}
            isLoading={loadingDiscard}
          >
            Discard
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default React.memo(CleanAndDiscardGitChangesModal);
